module.exports = __webpack_public_path__ + "static/media/no-group-image.fe5c4531.svg";